import React, { useEffect, useState } from "react";
import s from "./style.module.css";
import { VALIDATORS } from "./validators-contact";
import { Tooltip } from "react-tooltip";
import Api from "../../../service/ApiService";
import Message from "../../../model/Message";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    email: "",
    tel: "",
    sujet: "",
    message: "",
  });
  const [formErrors, setFormErrors] = useState({
    nom: "",
    prenom: "",
    email: "",
    tel: "",
    sujet: "",
    message: "",
  });
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    const allFieldsFilled = Object.entries(formData)
      .filter(([key]) => key !== "sujet" && key !== "tel")
      .every(([key, value]) => value.trim() !== "");
    const noErrors = Object.values(formErrors).every((error) => error === "");

    if (allFieldsFilled && noErrors) {
      setIsSubmitDisabled(false);
    } else {
      setIsSubmitDisabled(true);
    }
  }, [formData, formErrors]);

  function validate(fieldName, fieldValue) {
    setFormErrors({
      ...formErrors,
      [fieldName]: VALIDATORS[fieldName](fieldValue),
    });
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    validate(name, value);
  };

  const [sendMailResponse, setSendMailResponse] = useState(undefined);
  let secureMultipleSubmit = false;
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isSubmitDisabled && !secureMultipleSubmit) {
      secureMultipleSubmit = true;
      const message = new Message(
        e.target.nom.value,
        e.target.prenom.value,
        e.target.email.value,
        e.target.tel.value,
        e.target.sujet.value,
        e.target.message.value
      );
      if (!executeRecaptcha) {
        console.error("reCAPTCHA n'est pas prêt");
        return;
      }
      const token = await executeRecaptcha("submit");
      setSendMailResponse(await Api.sendMessage(token, message));
    }
  };

  return (
    <form onSubmit={handleSubmit} className={`${s.formControl} form-control`}>
      <div className={s.inlineFields}>
        <div className={`${s.formElement}`}>
          <input
            className={`${s.field} ${s.inputLitle} form-control`}
            placeholder="Nom *"
            type="text"
            id="nom"
            name="nom"
            value={formData.nom}
            onChange={handleChange}
          />
          <div className={s.error}>
            {formErrors.nom !== "" ? formErrors.nom : ""}
          </div>
        </div>
        <div className={`${s.formElement}`}>
          <input
            className={`${s.field} ${s.inputLitle} form-control`}
            placeholder="Prénom *"
            type="text"
            id="prenom"
            name="prenom"
            value={formData.prenom}
            onChange={handleChange}
          />
          <div className={s.error}>
            {formErrors.prenom !== "" ? formErrors.prenom : ""}
          </div>
        </div>
      </div>
      <div className={s.inlineFields}>
        <div className={`${s.formElement}`}>
          <input
            className={`${s.field} ${s.inputLitle} form-control`}
            placeholder="Email *"
            type="text"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
          <div className={s.error}>
            {formErrors.email !== "" ? formErrors.email : ""}
          </div>
        </div>
        <div className={`${s.formElement}`}>
          <input
            className={`${s.field} ${s.inputLitle} form-control`}
            placeholder="Numéro de téléphone"
            type="text"
            id="tel"
            name="tel"
            value={formData.tel}
            onChange={handleChange}
          />
          <div className={s.error}>
            {formErrors.tel !== "" ? formErrors.tel : ""}
          </div>
        </div>
      </div>
      <div className={`${s.formElement}`}>
        <input
          className={`${s.field} ${s.inputLitle} form-control`}
          placeholder="Sujet"
          type="text"
          id="sujet"
          name="sujet"
          value={formData.sujet}
          onChange={handleChange}
        />
        <div className={s.error}>{""}</div>
      </div>
      <div className={`${s.formElement}`}>
        <textarea
          className={`${s.field} form-control`}
          placeholder="Message *"
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          rows={5}
        />
        <div className={s.error}>
          {formErrors.message !== "" ? formErrors.message : ""}
        </div>
      </div>
      <div className="d-flex align-items-center">
        <button
          data-tooltip-id="my-tooltip"
          data-tooltip-content={
            isSubmitDisabled && sendMailResponse === undefined
              ? "Veuillez remplir les champs obligatoires (*)"
              : ""
          }
          data-tooltip-place="bottom"
          className={`btn ${
            isSubmitDisabled || sendMailResponse !== undefined
              ? `${s.submitButtonDisabled} ${
                  sendMailResponse !== undefined ? s.noClickEffect : ""
                }`
              : s.submitButton
          }`}
          type="submit"
        >
          Envoyer
        </button>{" "}
        <div
          className={`${
            sendMailResponse === undefined
              ? ""
              : sendMailResponse
              ? s.successSend
              : s.errorSend
          } ps-2`}
        >
          {sendMailResponse === undefined
            ? ""
            : sendMailResponse
            ? "Message envoyé avec succès"
            : "Erreur lors de l'envoi du message"}
        </div>
      </div>
      <Tooltip id="my-tooltip" />
    </form>
  );
}
